import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class CreateLastCallService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {LastCallRepository} deps.repository
   */
  constructor({repository}) {
    super()
    this._lastCallRepository = repository
  }

  @inlineError
  async execute({createLastCallRequestVO}) {
    const [error, response] = await this._lastCallRepository.createLastCall({
      createLastCallRequestVO
    })
    if (error) return Promise.reject(error)

    return response
  }
}
